import { render, staticRenderFns } from "./OrderForecast.vue?vue&type=template&id=596ba38e&scoped=true"
import script from "./OrderForecast.vue?vue&type=script&lang=js"
export * from "./OrderForecast.vue?vue&type=script&lang=js"
import style0 from "./OrderForecast.vue?vue&type=style&index=0&id=596ba38e&prod&lang=css"
import style1 from "./OrderForecast.vue?vue&type=style&index=1&id=596ba38e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596ba38e",
  null
  
)

export default component.exports